import type { Paths } from './types'

export const pathnameToActiveIndex = (pathname: string, paths: Paths) => {
  if (pathname.startsWith(paths.settings)) return 2

  if (pathname.startsWith(paths.list)) return 1

  return 0
}
